import React, { FunctionComponent, PropsWithChildren } from 'react';
import styled from 'styled-components';
import constants from '../common/theme/constants';
import KitButton from './KitButton';

interface KitSkipToContentProps {
  onClick: () => void;
}

const SKIP_LINK_HEIGHT = 32;

const StyledButton = styled(KitButton)`
  position: fixed;
  display: flex;
  left: 50%;
  transform: translateX(-50%);
  justify-content: center;
  align-items: center;
  height: ${SKIP_LINK_HEIGHT}px;
  top: -${SKIP_LINK_HEIGHT}px;
  padding: ${constants.spacing.absolute.xs}px ${constants.spacing.absolute.l}px;
  margin: 0;
  transition: top ${constants.duration.short}s;
  &:focus {
    top: 0;
  }
  white-space: nowrap;
  z-index: ${constants.zIndex.dropDown};
`;

const KitSkipToContent: FunctionComponent<PropsWithChildren<KitSkipToContentProps>> = (props) => {
  return <StyledButton onClick={props.onClick}>{props.children}</StyledButton>;
};

export default KitSkipToContent;
